// import { ReactElement } from 'react';
// import { Navigate } from 'react-router-dom';
// import { useIsAuthenticated } from '@azure/msal-react';

// interface PrivateRouteProps {
//   component: React.ComponentType;
// }

// const PrivateRoute = ({ component: Component }: PrivateRouteProps): ReactElement | null => {
//   const isAuthenticated = useIsAuthenticated(); // <-- Correctly checks MSAL's state

//   if (!isAuthenticated) {
//     return <Navigate to="/login" />;
//   }

//   return <Component />;
// };

// export default PrivateRoute;

// import React, { ReactElement, useEffect, useState } from "react";
// import { Navigate, useNavigate } from "react-router-dom";
// import { useIsAuthenticated, useMsal } from "@azure/msal-react";
// import { apiScopes } from '../config/msalConfig';

// interface PrivateRouteProps {
//   component: React.ComponentType;
// }

// const PrivateRoute = ({ component: Component }: PrivateRouteProps): ReactElement | null => {
//   const isAuthenticated = useIsAuthenticated();
//   const { instance, accounts } = useMsal();
//   const [role, setRole] = useState<string | null>(null);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchRole = async () => {
//       if (!isAuthenticated || accounts.length === 0) {
//         setLoading(false);
//         return;
//       }

//       try {
//         // ✅ get access token
//         const response = await instance.acquireTokenSilent({
//                   ...apiScopes,
//                   account: accounts[0],
//                 });

//         const token = response.accessToken;

//         // ✅ send token to backend
//         const backendResponse = await fetch("http://localhost:5000/api/auth/verify-role", {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         const data = await backendResponse.json();
//         console.log("Role from backend:", data);

//         setRole(data.role);

//         // 🚀 redirect based on role
//         if (data.role === "Super Admin") {
//           navigate("/forms", { replace: true });
//         } else if (data.role === "Center Admin") {
//           navigate("/fee-tax", { replace: true });
//         }
//       } catch (err) {
//         console.error("Error fetching role:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchRole();
//   }, [isAuthenticated, accounts, instance, navigate]);

//   if (!isAuthenticated) {
//     return <Navigate to="/login" replace />;
//   }

//   if (loading) {
//     return <div>Loading...</div>; // ⏳ spinner placeholder
//   }

//   return <Component />;
// };

// export default PrivateRoute;

// import React, { ReactElement, useEffect, useState } from "react";
// import { Navigate, useLocation } from "react-router-dom";
// import { useIsAuthenticated, useMsal } from "@azure/msal-react";
// import { apiScopes } from "../config/msalConfig";
// import { roleRoutes } from "../config/rolesRoute";

// interface PrivateRouteProps {
//   component: React.ComponentType;
// }

// const PrivateRoute = ({ component: Component }: PrivateRouteProps): ReactElement | null => {
//   const isAuthenticated = useIsAuthenticated();
//   const { instance, accounts } = useMsal();
//   const [role, setRole] = useState<string | null>(null);
//   const [loading, setLoading] = useState(true);
//   const location = useLocation();

//   useEffect(() => {
//     const fetchRole = async () => {
//       if (!isAuthenticated || accounts.length === 0) {
//         setLoading(false);
//         return;
//       }

//       try {
//         const response = await instance.acquireTokenSilent({
//           ...apiScopes,
//           account: accounts[0],
//         });

//         const token = response.accessToken;

//         const backendResponse = await fetch("http://localhost:5000/users/currentUser", {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         const data = await backendResponse.json();
//         setRole(data.displayName);
//       } catch (err) {
//         console.error("Error fetching role:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchRole();
//   }, [isAuthenticated, accounts, instance]);

//   if (!isAuthenticated) {
//     return <Navigate to="/login" replace />;
//   }

//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   // ✅ Check if role is allowed for current path
//   if (role && roleRoutes[role]) {
//     const allowedRoutes = roleRoutes[role];
//     if (!allowedRoutes.includes(location.pathname)) {
//       // if not allowed → send to role’s default first page
//       return <Navigate to={allowedRoutes[0]} replace />;
//     }
//   }

//   return <Component />;
// };

// export default PrivateRoute;

// import React, { ReactElement, useEffect, useState } from "react";
// import { Navigate, useLocation } from "react-router-dom";
// import { useIsAuthenticated } from "@azure/msal-react";
// import { roleRoutes } from "../config/rolesRoute";

// interface PrivateRouteProps {
//   component: React.ComponentType;
// }

// const PrivateRoute = ({ component: Component }: PrivateRouteProps): ReactElement | null => {
//   const isAuthenticated = useIsAuthenticated();
//   const [role, setRole] = useState<string | null>(null);
//   const [loading, setLoading] = useState(true);
//   const location = useLocation();

//   useEffect(() => {
//     if (!isAuthenticated) {
//       setLoading(false);
//       return;
//     }

//     // Get the stored user data string from session storage
//     const storedDataString = sessionStorage.getItem('backendResponse');

//     if (storedDataString) {
//       try {
//         // Parse the string back into an object
//         const userData = JSON.parse(storedDataString);
//         // Set the role from the stored data (using 'displayName' as in your original code)
//         setRole(userData.displayName);
//       } catch (error) {
//         console.error("Failed to parse user data from session storage:", error);
//         // Handle cases where sessionStorage might contain invalid JSON
//         setRole(null);
//       }
//     }

//     setLoading(false); // Finished checking, stop loading

//   }, [isAuthenticated]);

//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   if (!isAuthenticated) {
//     return <Navigate to="/login" replace />;
//   }

//   // ✅ Check if role is allowed for current path
//   if (role && roleRoutes[role]) {
//     const allowedRoutes = roleRoutes[role];
//     if (!allowedRoutes.includes(location.pathname)) {
//       // if not allowed → send to role’s default first page
//       return <Navigate to={allowedRoutes[0]} replace />;
//     }
//   } else if (isAuthenticated && !role) {
//     // Optional: Handle case where user is authenticated but role couldn't be found
//     // This could be a redirect to a generic dashboard or an error page.
//     // For now, we can let it fall through, but it's good to be aware of.
//     console.warn("User is authenticated but no role was found in session storage.");
//   }

//   return <Component />;
// };

// export default PrivateRoute;

// import React, { ReactElement, useEffect, useState } from "react";
// import { Navigate, useLocation } from "react-router-dom";
// import { useIsAuthenticated } from "@azure/msal-react";
// import { roleRoutes } from "../config/rolesRoute";

// interface PrivateRouteProps {
//   component: React.ComponentType;
// }

// const PrivateRoute = ({
//   component: Component,
// }: PrivateRouteProps): ReactElement | null => {
//   const isAuthenticated = useIsAuthenticated();
//   const location = useLocation();

//   const [roleKey, setRoleKey] = useState<string | null>(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     if (!isAuthenticated) {
//       setLoading(false);
//       return;
//     }

//     const storedDataString = sessionStorage.getItem("backendResponse");

//     if (!storedDataString) {
//       setRoleKey(null);
//       setLoading(false);
//       return;
//     }

//     try {
//       const userData = JSON.parse(storedDataString);

//       // ✅ SAFELY extract role key
// const assignedRoleKey =
//   userData?.roleAssignments?.[0]?.roleId?.key?.trim() ?? null;

//       setRoleKey(assignedRoleKey);
//     } catch (error) {
//       console.error("Failed to parse backendResponse:", error);
//       setRoleKey(null);
//     }

//     setLoading(false);
//   }, [isAuthenticated]);

//   /* -------------------- UI STATES -------------------- */

//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   if (!isAuthenticated) {
//     return <Navigate to="/login" replace />;
//   }

//   if (!roleKey) {
//     console.warn("Authenticated but role not found");
//     return <Navigate to="/unauthorized" replace />;
//   }

//   /* -------------------- ROLE BASED ACCESS -------------------- */

// const allowedRoutes = roleRoutes[roleKey];

// if (!allowedRoutes) {
//   return <Navigate to="/unauthorized" replace />;
// }

// const isAllowed = allowedRoutes.some(route =>
//   location.pathname.startsWith(route)
// );

// if (!isAllowed) {
//   return <Navigate to={allowedRoutes[0]} replace />;
// }

//   /* -------------------- ALLOWED -------------------- */

//   return <Component />;
// };

// export default PrivateRoute;

import React, { ReactElement, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useIsAuthenticated } from "@azure/msal-react";
import { roleRoutes } from "../config/rolesRoute";

interface PrivateRouteProps {
  component: React.ComponentType;
}

const PrivateRoute = ({
  component: Component,
}: PrivateRouteProps): ReactElement | null => {
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();

  const [roleKey, setRoleKey] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isAuthenticated) {
      setLoading(false);
      return;
    }

    const checkUserRole = () => {
      const storedDataString = sessionStorage.getItem("backendResponse");

      if (!storedDataString) {
        return; // wait until backendResponse is stored
      }

      try {
        const userData = JSON.parse(storedDataString);

        // const assignedRoleKey =
        //   userData?.roleAssignments?.[0]?.roleId?.key?.trim() ?? null;

        // setRoleKey(assignedRoleKey);

        const storedStation = sessionStorage.getItem("assignedStation");

        if (storedStation) {
          setRoleKey(storedStation);
        } else {
          const assignedRoleKey =
            userData?.roleAssignments?.[0]?.roleId?.key?.trim() ?? null;

          setRoleKey(assignedRoleKey);
        }
      } catch (error) {
        console.error("Failed to parse backendResponse:", error);
        setRoleKey(null);
      }

      setLoading(false);
    };

    // run immediately
    checkUserRole();

    // check every 500ms until backendResponse exists
    const interval = setInterval(checkUserRole, 500);

    return () => clearInterval(interval);
  }, [isAuthenticated]);

  /* -------------------- LOADING -------------------- */

  if (loading) {
    return <div>Loading user...</div>;
  }

  /* -------------------- NOT AUTHENTICATED -------------------- */

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  /* -------------------- ROLE NOT FOUND -------------------- */

  if (!roleKey) {
    console.warn("Authenticated but role not found");
    return <Navigate to="/unauthorized" replace />;
  }

  /* -------------------- ROLE BASED ACCESS -------------------- */

  const allowedRoutes = roleRoutes[roleKey];

  if (!allowedRoutes) {
    return <Navigate to="/unauthorized" replace />;
  }

  const isAllowed = allowedRoutes.some((route) =>
    location.pathname.startsWith(route),
  );

  if (!isAllowed) {
    return <Navigate to={allowedRoutes[0]} replace />;
  }

  /* -------------------- ALLOWED -------------------- */

  return <Component />;
};

export default PrivateRoute;
